module.exports = __webpack_public_path__ + "img/favorite.f42ef0ad.svg";